import { Controller } from "@hotwired/stimulus"
import { requestConfirm } from "../util"
import { turboFetch } from "../util/common"

// Connects to the data-controller="manage-stream"
export default class extends Controller {
  static targets = ["preview", "room"]
  static values = { url: String }

  async closeStream(event) {
    event.preventDefault()
    event.stopPropagation()

    const confirmationResult = await requestConfirm({ modal: "default", text: "Are you sure you want to close stream?" })

    if (!confirmationResult) return

    await this.updateStreamStatus("close")
  }

  async completeStream(event) {
    event.preventDefault()
    event.stopPropagation()

    const confirmationResult = await requestConfirm({ modal: "default", text: "Are you sure you want to complete stream?" })

    if (!confirmationResult) return

    await this.updateStreamStatus("complete")
  }

  async restoreStream(event) {
    event.preventDefault()
    event.stopPropagation()

    const confirmationResult = await requestConfirm({
      modal: "default-confirm",
      data: {
        title: "Are you sure you want to restore this stream?",
        text: "All previous settings will be reinstated.",
        confirmButtonText: "Restore"
      }
    })

    if (!confirmationResult) return

    await this.updateStreamStatus("restore")
  }

  async updateStreamStatus(status) {
    await turboFetch(
      this.urlValue,
      {
        method: "PATCH",
        body: JSON.stringify({ live_event: { status: status } })
      }
    )
  }
}
